export default __webpack_public_path__ + "static/media/ar-button.352cce8b.png";